import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=36655970&scoped=true"
import script from "./ChannelEdit.vue?vue&type=script&lang=js"
export * from "./ChannelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36655970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36655970')) {
      api.createRecord('36655970', component.options)
    } else {
      api.reload('36655970', component.options)
    }
    module.hot.accept("./ChannelEdit.vue?vue&type=template&id=36655970&scoped=true", function () {
      api.rerender('36655970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/channels/ChannelEdit.vue"
export default component.exports